const atualizarEntradasNF = (state, entradasNF) => {
    state.entradasNF = entradasNF;
}

const atualizarEntradaNF = (state, entradaNF) => {
    state.entradaNF = entradaNF;
}
const atualizarPedidosNF = (state, pedidosNF) => {
    state.pedidosNF = pedidosNF;
}

const updateEntradaNF = (state, entradaNF) => {
    if (!entradaNF || entradaNF.id == null) return;

    const index = state.entradasNF.findIndex(item => item.id === entradaNF.id);
    if (index >= 0) {
        state.entradasNF.splice(index, 1, JSON.parse(JSON.stringify(entradaNF)));
    }
}

export default {
    atualizarEntradasNF,
    atualizarEntradaNF,
    atualizarPedidosNF,
    updateEntradaNF
}
